import { render, staticRenderFns } from "./CargarCotizacion.vue?vue&type=template&id=10aeaa4f&scoped=true&"
import script from "./CargarCotizacion.vue?vue&type=script&lang=js&"
export * from "./CargarCotizacion.vue?vue&type=script&lang=js&"
import style0 from "./CargarCotizacion.vue?vue&type=style&index=0&id=10aeaa4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aeaa4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFileInput,VIcon})
